module.exports = __webpack_public_path__ + "assets/img/6ccf5b46430fe3d1a9b1a405116349aa.png";